import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.company-created-success', {
        url: '/companyCreated-success',
        templateUrl: require('./company-created-success.html'),
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/company-created-success/company-created-success.state.js